import React from 'react';
import Router from '@module/router';

import I18n from '@module/i18n';
import Assets from '@app/assets';
import Browser from '@wetransfer/concorde-browser';

import AdGallery from '@component/advertise/adgallery';

const home = () => {
  let guidelinesButton = null;

  if (Browser.isMobile) {
    guidelinesButton = (
      <a className="button button__secondary" href="/advertise/guidelines">
        {I18n.t('page.advertise.button.guidelines')}
      </a>
    );
  }

  return (
    <div className="page-advertise">
      <div className="page-advertise__intro">
        <h1>{I18n.t('page.advertise.home.intro.title')}</h1>
        <p>{I18n.t('page.advertise.home.intro.description')}</p>
        <a className="button button--enabled" href="/advertise/contact">
          {I18n.t('page.advertise.button.contact')}
        </a>
        {guidelinesButton}
      </div>

      <hr />
      <div className="page-advertise__stats">
        <div className="stat">
          <div className="number">
            5.0
            <span>&times;</span>
          </div>
          <div className="content">
            <h4>{I18n.t('page.advertise.home.stats.ctr')}</h4>
            <p>
              {I18n.t('page.advertise.home.stats.our_number', {
                percentage: '0.70%',
              })}
            </p>
            <p>
              {I18n.t('page.advertise.home.stats.industry', {
                percentage: '0.14%',
              })}
            </p>
          </div>
        </div>
        <div className="stat">
          <div className="number">
            3.5
            <span>&times;</span>
          </div>
          <div className="content">
            <h4>{I18n.t('page.advertise.home.stats.engagement')}</h4>
            <p>
              {I18n.t('page.advertise.home.stats.our_number', {
                percentage: '11.9%',
              })}
            </p>
            <p>
              {I18n.t('page.advertise.home.stats.industry', {
                percentage: '3.36%',
              })}
            </p>
          </div>
        </div>
        <div className="stat">
          <div className="number">
            1.3
            <span>&times;</span>
          </div>
          <div className="content">
            <h4>{I18n.t('page.advertise.home.stats.view_time')}</h4>
            <p>
              {I18n.t('page.advertise.home.stats.our_time', {
                percentage: '35.4s',
              })}
            </p>
            <p>
              {I18n.t('page.advertise.home.stats.industry', {
                percentage: '28.2s',
              })}
            </p>
          </div>
        </div>
        <div className="source">
          <p
            dangerouslySetInnerHTML={{
              __html: I18n.t('page.advertise.home.stats.source', {
                name: 'richmediagallery.com',
                url: 'https://www.richmediagallery.com/tools/benchmarks',
              }),
            }}
          />
        </div>
      </div>

      <hr />
      <div className="page-advertise__gallery">
        <h3>{I18n.t('page.advertise.home.favourite.title')}</h3>
        <p
          dangerouslySetInnerHTML={{
            __html: I18n.t('page.advertise.home.favourite.description'),
          }}
        />
        <div className="page-advertise__featured">
          <AdGallery
            image={Assets.lookup('gallery/piper-heidsieck.jpg')}
            title="Piper-Heidsieck"
            type="Animated"
            onPreview={() => Router.navigateTo('/advertise/gallery')}
            large={true}
          />
          <AdGallery
            image={Assets.lookup('gallery/adobe-stock.jpg')}
            title="Adobe Stock"
            type="Static"
            onPreview={() => Router.navigateTo('/advertise/gallery')}
          />
          <AdGallery
            image={Assets.lookup('gallery/wrangler.jpg')}
            title="Wrangler"
            type="Static"
            onPreview={() => Router.navigateTo('/advertise/gallery')}
          />
        </div>
        <a className="button button__secondary" href="/advertise/gallery">
          {I18n.t('page.advertise.button.gallery')}
        </a>
      </div>
    </div>
  );
};

export default home;
